import { ROUTES } from "./routeConstant";

export const firstParent = "home";
export const firstMenu = "home";
export const firstUrl = ROUTES.HOME;
